import { routerStore } from "csi/state/rootStore";
import { ComplianceAnalysisCardFLDS } from "./ComplianceAnalysisCardFLDS";
import { ComplianceAnalysisSlimOnInstance, DojoViewContext, QueryContext } from "./ComplianceAnalysisSlimOnInstance";
import { rootCache } from "csi/state/Cache";

const queryAttr: string = "ParentDataSheetRevision";
const queryPath: string = "Child:__Parent__";
const viewId: string = "Properties";
const viewNodeType: string = "ProductComplianceAnalysis";

export const ComplianceAnalysisSlimOnInstanceFLDS = () => {
	const { locationNode, locationType } = routerStore;
	const allowedBaseProductTypes = ["Food", "FormulatedMaterial", "Style", "Material"];

	const parentNode = rootCache.get(locationNode?.__Parent__);
	const parentNodeType = parentNode?.$Type;
	let baseProductType = "";
	if (locationType === "FoodLabelDataSheet" && !allowedBaseProductTypes.includes(parentNodeType)) {
		const parentLabelNode = rootCache.get(parentNode?.__Parent__);
		baseProductType = parentLabelNode?.$Type || "";
	} else {
		baseProductType = parentNodeType || "";
	}

	// Sanity check, if baseProductType still isn't one of the base products then resort to normal view to avoid errors
	if (!allowedBaseProductTypes.includes(baseProductType)) {
		baseProductType = "";
	}

	return ComplianceAnalysisSlimOnInstance(
		ComplianceAnalysisCardFLDS,
		queryAttr,
		QueryContext.LOCATION_REVISION_NODE,
		queryPath,
		DojoViewContext.SELECTED_NODE,
		baseProductType + viewId,
		viewNodeType,
		"list",
	);
};

export default ComplianceAnalysisSlimOnInstanceFLDS;
